/* eslint-disable import/prefer-default-export */
export const COMPONENT_COPY_SUFFIX = '_copy-';
export const COMPONENT_CLASSNAME = '__component-slot';
